import { siteConfig } from "@/config/site";

export const DEFAULT_SEO = {
  openGraph: {
    title: "Helios - Text message marketing that converts",
    description:
      "Turn your leads into customers. Helios provides all the tools to help you craft perfect SMS campaigns and automate the rest.",
    type: "website",
    locale: "en",
    url: "https://sendhelios.com",
    site_name: "Helios",
    images: [
      {
        url: siteConfig.ogImage,
        width: 1200,
        height: 630,
        alt: siteConfig.name,
      },
    ],
  },
  twitter: {
    handle: "@sendhelios",
    site: "@sendhelios",
    cardType: "summary_large_image",
  },
};
